import React, { Component } from 'react'
import ReactDOM from 'react-dom'

//const Modal = function (props) {
class Modal extends Component {
  constructor(props) {
    super(props)
    // Pre-bind your event handler, or define it as a fat arrow in ES7/TS
    this.handleModalClose = this.handleModalClose.bind(this)
  }

  handleModalClose = (event) => {
    const { onCloseModalBoxClick } = this.props
    if (onCloseModalBoxClick) {
      onCloseModalBoxClick()
    }
  }

  componentDidMount() {
    ReactDOM.findDOMNode(this).addEventListener(
      'wbClose',
      this.handleModalClose,
    )
  }

  componentWillUnmount() {
    ReactDOM.findDOMNode(this).removeEventListener(
      'wbClose',
      this.handleModalClose,
    )
  }

  render = () => {
    const props = this.props

    return (
      <wb-modal mode={!!props.type ? props.type : 'prompt'} close-on-escape-key>
        <wb-modal-content headline={props.header}>
          {/* {
            props.onCloseModalBoxClick
            && <button
              type="button"
              className="wb-m-lightbox-2__close"
              onClick={props.onCloseModalBoxClick}>
              ✕
            </button>
          } */}
          {props.children && (
            <p className="wb-type-copy-secondary">{props.children}</p>
          )}
        </wb-modal-content>
        <wb-modal-footer>
          {props.onCancelClick && (
            <button
              type="button"
              className="wb-button wb-button--secondary wb-button--small"
              onClick={props.onCancelClick}
            >
              Cancel
            </button>
          )}
          {props.onConfirmClick && (
            <button
              type="button"
              className="wb-button wb-button--primary wb-button--small"
              onClick={props.onConfirmClick}
            >
              Confirm
            </button>
          )}
          {props.onCloseButton && (
            <React.Fragment>
              <button
                type="button"
                className="wb-button wb-button--secondary wb-button--small"
                onClick={props.onCloseButton}
              >
                Close
              </button>
              <button
                type="button"
                className="wb-button wb-button--primary wb-button--small"
                onClick={props.onCloseButton}
              >
                OK
              </button>
            </React.Fragment>
          )}
        </wb-modal-footer>
      </wb-modal>
    )
  }
}

export default Modal
